import { render, staticRenderFns } from "./SuppPdpSignup.vue?vue&type=template&id=30166e21&lang=pug"
import script from "./SuppPdpSignup.vue?vue&type=script&lang=js"
export * from "./SuppPdpSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Anchor: require('/home/docker/code/frontend/components/Anchor.vue').default})
